<template>
	<el-container id="certificate_download">
        <div class="con">
            <leftbox></leftbox>
            <div class="live">
			    <div class="titBox">
			    	<p class="tit">学习统计
			    	</p>
			    </div>
                <div class="table" style="padding: 10px 30px;width: 100%;box-sizing: border-box;">
                    <el-table
                        :data="student_statistics"
                        border
                        stripe
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="课程"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="course_type_format"
                            label="类型"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="all_study_hour"
                            label="总学时">
                        </el-table-column>
                        <el-table-column
                            prop="done_study_hour"
                            label="已完成学时">
                        </el-table-column>
                    </el-table>
                </div>
                
            </div>
        </div>
    </el-container>
</template>
<script>
import leftbox from '@/components/leftBox.vue'
export default {
	name: 'certificate_download'
    ,components:{
        leftbox
    }
	,data () {
		return {
            class_show:0,
            student_statistics: []
		}
	}
	,mounted:function(){
        this.get_student_statistics()
	}
	,watch:{
	}
	,computed:{
        
	}
	,methods:{
        // 获取学习统计
		get_student_statistics(){
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			this.$ajax.get(serverSrc + qianzui +"/study_stat/course")
			.then((res)=>{
                // console.log(res);
				// let resData = res.data
				this.student_statistics = res.data.data.datas

				// if(resData.code == 0 && resData.data.title){
				// 	this.kaoshiList.push(resData.data)
				// 	// this.kaoshiList.push(resData.data)
				// }
			})
		},
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/certificate_download.vue